import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import Header from '../components/Header';
import Footer from '../components/Footer';
import faviconSmall from '../assets/img/favicon-16x16.png';
import faviconBig from '../assets/img/favicon-32x32.png';
import logo from '../assets/img/logo.png';
import '../styles/main.scss';

const TemplateWrapper = ({ children, location }) => (
    <div>
        <Helmet defaultTitle="Youth Camps For Christ, Inc.">
            <meta
                name="description"
                content="Youth Camps For Christ, Inc. owns and operates Camp Willow Springs and Camp Willow Run. Both camps are non-profit, interdenominational Christian camps and retreat centers located on beautiful Lake Gaston near Littleton, NC."
            />
            <meta name="image" content={logo} />
            <meta name="og:type" content="website" />
            <meta name="og:site_name" content="Youth Camps For Christ, Inc." />
            <meta name="og:image" content={logo} />
            <meta name="og:url" content="http://www.youthcampsforchrist.org" />
            <link rel="icon" type="image/png" sizes="32x32" href={faviconBig} />
            <link
                rel="icon"
                type="image/png"
                sizes="16x16"
                href={faviconSmall}
            />
        </Helmet>
        <Header location={location} />
        <div>{children()}</div>
        <Footer />
    </div>
);

TemplateWrapper.propTypes = {
    children: PropTypes.any
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js